import { render, staticRenderFns } from "./SlsPT_Total.vue?vue&type=template&id=1794709f"
import script from "./SlsPT_Total.vue?vue&type=script&lang=js"
export * from "./SlsPT_Total.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports